module.exports = __webpack_public_path__ + "static/img/marco-guerrero-uuuXb8gkJKI-unsplash_thumb.c7a111e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/marco-guerrero-uuuXb8gkJKI-unsplash_thumb.png
// module id = 5Iez
// module chunks = 4